import React from 'react'
import { Link } from 'react-router-dom'

export default function Navbar() {
    return (
        <React.Fragment>
            <nav>
                <button className='navtogglebtn' onClick={navToggle}>|||</button>
                <h3>StudyMaterialLol</h3>
            </nav>
            <div className="sidebar">
                <ul>
                    {/* <h3 className='sidebarheading'>Pages</h3> */}
                    <Link to='/'><li>Home</li></Link>
                    <a href='https://drive.google.com/drive/folders/1lsaN4C8ZBUmFo3oOvCMakF7x00Rdoci4?usp=sharing' target='_blank'><li>Lazy Package (incl. model papers)</li></a>
                    <a href='https://vtu.ac.in/en/' target='_blank'><li>VTU Website</li></a>
                    <Link to='/contact'><li>Contact Developer</li></Link>
                    <h3 className='sidebarheading'>Subjects</h3>
                    <Link to='/physics'><li>Physics</li></Link>
                    <Link to='/maths'><li>Maths</li></Link>
                    <Link to='/basicelectricalengineering'><li>Basic Electrical Engineering</li></Link>
                    <Link to='/civil'><li>Civil</li></Link>
                    <Link to='/engineeringvisualization'><li>Engineering Visualization</li></Link>
                    <Link to='/english'><li>English</li></Link>
                    <Link to='/innovationdesignthinking'><li>Innovation & Design Thinking</li></Link>
                </ul>
            </div>
        </React.Fragment>
    )
}

function navToggle() {
    let sideBar = document.querySelector('.sidebar')
    let navToggleBtn = document.querySelector('.navtogglebtn')
    if (sideBar.style.left === '0px') {
        sideBar.style.left = '-330px'
        navToggleBtn.innerHTML = '|||'
    }
    else {
        sideBar.style.left = '0px'
        navToggleBtn.innerHTML = 'x'
    }
}
